import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

import LoadingWrapper from 'shared/components/LoadingWrapper';
import Modal from 'shared/components/Modal';
import Image from 'shared/components/Image';
import DataPair from 'shared/components/DataPair';
import { formatDate } from 'shared/utils/utils';
import { getSourceType } from 'shared/utils/source';
import { FETCH_SOURCE_STATUS } from 'services/source/actions';
import { getSourceToView } from 'services/source/getters';

const VIEW_SOURCE_MODAL_NAME = 'view-source-modal';

const MODAL_OVERLAY_CLASS_NAME = 'view-source-modal__modal-overlay';
const MODAL_CONTAINER_CLASS_NAME = 'view-source-modal__modal-container';
const MODAL_HEADER_CLASS_NAME = 'view-source-modal__modal-header';
const MODAL_CONTENT_CLASS_NAME = 'view-source-modal__modal-content';
const MODAL_CLOSE_ICON_CLASS_NAME = 'view-source-modal__modal-close-icon';

const StyledModal = styled(Modal)`
  & {
    .${MODAL_OVERLAY_CLASS_NAME} {
      padding-top: 5.34rem;
    }

    .${MODAL_CONTAINER_CLASS_NAME} {
      padding: 0 13.17rem;
    }

    .${MODAL_HEADER_CLASS_NAME} {
      margin: 2.3rem 0 3.6rem;
    }

    .${MODAL_CONTENT_CLASS_NAME} {
      margin: 0;
    }

    .${MODAL_CLOSE_ICON_CLASS_NAME} {
      right: 0;
    }
  }
`;

const StyledContainer = styled.div`
  display: flex;
`;

const StyledImageContainer = styled.div`
  width: 14.41%;
  margin-right: 5rem;
`;

const StyledContentContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledImage = styled(Image)`
  width: 13.3rem;
  height: 13.3rem;
`;

const StyledContentHeader = styled.div`
  margin-bottom: 2.6rem;
`;

const StyledSourceName = styled.span`
  font-size: 2rem;
  font-weight: 700;
`;

const StyledInfoContainer = styled.div`
  display: flex;
`;

const StyledInfoWrapper = styled.div``;

const StyledDescriptionWrapper = styled.div`
  max-width: 41rem;
  margin-right: 5rem;
`;

const StyledDataPair = styled(DataPair)`
  &:not(:last-child) {
    margin-bottom: 1.916rem;
  }
`;

const StyledSourceDescription = styled.div``;

const StyledLoadingWrapper = styled(LoadingWrapper)`
  height: 100%;
`;

const ViewSourceModal = () => {
  const source = useSelector(getSourceToView);

  if (!source) {
    return null;
  }

  return (
    <StyledModal
      name={VIEW_SOURCE_MODAL_NAME}
      overlayClassName={MODAL_OVERLAY_CLASS_NAME}
      containerClassName={MODAL_CONTAINER_CLASS_NAME}
      headerClassName={MODAL_HEADER_CLASS_NAME}
      contentClassName={MODAL_CONTENT_CLASS_NAME}
      closeIconClassName={MODAL_CLOSE_ICON_CLASS_NAME}
      title='View Source'
    >
      <StyledLoadingWrapper actionToQuery={FETCH_SOURCE_STATUS}>
        <StyledContainer>
          {source.iconUrl && (
            <StyledImageContainer>
              <StyledImage src={source.iconUrl} />
            </StyledImageContainer>
          )}
          <StyledContentContainer>
            <StyledContentHeader>
              <StyledSourceName>{source.name}</StyledSourceName>
            </StyledContentHeader>
            <StyledInfoContainer>
              {source.description && (
                <StyledDescriptionWrapper>
                  <StyledSourceDescription>{source.description}</StyledSourceDescription>
                </StyledDescriptionWrapper>
              )}
              <StyledInfoWrapper>
                {source.type && <StyledDataPair label='Type'>{getSourceType(source.type)}</StyledDataPair>}
                {source.lastSubmitted && (
                  <StyledDataPair label='Submission'>{formatDate(source.lastSubmitted)}</StyledDataPair>
                )}
                {source.subscribed && (
                  <StyledDataPair label='Subscribed'>{formatDate(source.subscribed)}</StyledDataPair>
                )}
              </StyledInfoWrapper>
            </StyledInfoContainer>
          </StyledContentContainer>
        </StyledContainer>
      </StyledLoadingWrapper>
    </StyledModal>
  );
};

export { VIEW_SOURCE_MODAL_NAME };

export default ViewSourceModal;
